import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import axiosInstance from '../axiosConfig';
import Cookies from 'js-cookie';

// Initialize Stripe with your publishable key
// const stripePromise = loadStripe('pk_test_51PoFNCRsETdjcfB7zTywrtJbNn6UPBoASAHVtTsnswuhn4lePjG7xOMFC48EVTusgSWJjWmJBlxO0lDPvYmmuAom00bsyH2Ke6');
const stripePromise = loadStripe('pk_live_51PoFNCRsETdjcfB7u0auLNLvRcl45KGBnuOHsuhJhi1tsaaHwOHQ9APE6HVPO06jh1XXOYSRmf8H5RQHpuFdIb7Y00zx1U0r0X');
// Main component for ACH setup
const ACHPaymentButton = ({ 
  selectedListing, 
  listingTitle, 
  amount, 
  selectedDate
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [validationError, setValidationError] = useState(null);

  const validateInputs = () => {
    // Clear previous errors
    setValidationError(null);
    
    // Check required fields
    if (!selectedListing) {
      setValidationError('Please select a property.');
      return false;
    }
    
    if (!amount || parseFloat(amount) <= 0) {
      setValidationError('Please enter a valid payment amount.');
      return false;
    }
    
    if (!selectedDate) {
      setValidationError('Please select a payment date.');
      return false;
    }
    
    return true;
  };

  const handleACHSetup = async () => {
    // Validate all inputs first
    if (!validateInputs()) {
      return;
    }
    
    try {
      setLoading(true);
      setError(null);
      
      const csrfToken = Cookies.get('csrftoken');
      const paymentDayValue = parseInt(selectedDate.split('-')[2], 10);
      
      // console.log('Creating ACH setup session:', {
      //   listing_id: selectedListing,
      //   listing_title: listingTitle,
      //   amount: parseFloat(amount).toFixed(2),
      //   payment_day: paymentDayValue
      // });
      
      // Create a checkout session for ACH setup
      const response = await axiosInstance.post(
        '/payments/create-ach-checkout/',
        {
          listing_id: selectedListing,
          listing_title: listingTitle,
          amount: parseFloat(amount).toFixed(2),
          payment_day: paymentDayValue
        },
        {
          headers: {
            'X-CSRFToken': csrfToken,
            'Content-Type': 'application/json'
          }
        }
      );

      // Get the session ID
      const { sessionId } = response.data;
      
      // Redirect to Stripe Checkout
      const stripe = await stripePromise;
      const { error } = await stripe.redirectToCheckout({
        sessionId
      });
      
      if (error) {
        console.error('Error redirecting to Checkout:', error);
        setError(error.message);
        setLoading(false);
      }
      
    } catch (err) {
      console.error('Error creating checkout session:', err);
      setError(err.response?.data?.error || 'Failed to set up ACH payment. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="ach-payment-container">
      {validationError && (
        <div className="validation-error" style={{ color: 'red', marginBottom: '10px' }}>
          {validationError}
        </div>
      )}
      
      <button 
        className="payment-btn ach-btn"
        onClick={handleACHSetup}
        disabled={loading}
      >
        {loading ? 'Setting up...' : 'Set Up Monthly ACH Payments'}
      </button>
      
      {error && (
        <div className="error-message" style={{ color: 'red', marginTop: '10px' }}>
          {error}
        </div>
      )}
      
      <div className="ach-info">
        <p>
          ACH payments will be automatically withdrawn from your bank account 
          each month. This helps you avoid late fees and keeps your payments on schedule.
        </p>
        <p>
          <strong>Benefits:</strong>
          <ul>
            <li>No late fees - payments are processed automatically</li>
            <li>Convenient - no need to remember payment dates</li>
            <li>Secure - Stripe handles your banking information securely</li>
            <li>Flexible - you can cancel or update payment details anytime</li>
          </ul>
        </p>
      </div>
    </div>
  );
};

export default ACHPaymentButton; 